import {Component, Module} from 'app/decorators';
import _ from 'lodash';

import ProductPicker from 'app/directives/product.picker';
import tpl from './chemical.products.html';


@Module({
    name: "app.admin.components.chemica.program",
    modules: [
        ProductPicker,
    ]
})
@Component({
    selector: 'blnd-chemical-products',
    bindings: {
        ngModel: '=',
        mode: '@',
        company: '<',
    },
    template: tpl,
})
export default class C {
    constructor() {
        "ngInject";
        this.ngModel = this.ngModel || [];
        this.mode = this.mode || 'view';
    }

    addProduct () {
        this.ngModel.push({});
    }

    removeProduct (product) {
        let index = this.ngModel.indexOf(product);
        this.ngModel.splice(index, 1);
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/components/chemical.products.js